"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FieldGroup = _interopRequireDefault(require("../FieldGroup"));
var _constants = require("../constants");
var _uuid = require("uuid");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calculateIsOptionVisible = (optionValue, controllerValue) => {
  if (Array.isArray(controllerValue)) {
    if (controllerValue.includes(optionValue)) {
      return true;
    }
  }
  if (optionValue === controllerValue) {
    return true;
  }
  return false;
};
var ConditionalField = props => {
  var _field$options;
  var {
    field = {},
    conditionalFieldControllerValues = [],
    fieldData = {},
    fieldReferences = {},
    fieldValues = {},
    language = _constants.CONTENTFUL_LOCALE.en,
    clickedSubmit = false
  } = props;
  var optionValues = (0, _react.useMemo)(() => {
    return conditionalFieldControllerValues;
  }, [conditionalFieldControllerValues]);
  var optionsRendered = field === null || field === void 0 || (_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.map(option => {
    var _option$conditionalFi, _option$conditionalFi2, _option$conditionalFi3, _option$conditionalFi4, _option$conditionalFi5, _option$conditionalFi6, _option$conditionalFi7, _option$conditionalFi8;
    var isFieldVisible = calculateIsOptionVisible(option.value, optionValues.length > 0 ? optionValues : conditionalFieldControllerValues);
    option === null || option === void 0 || (_option$conditionalFi = option.conditionalFieldGroup) === null || _option$conditionalFi === void 0 || _option$conditionalFi.fields.forEach(field => {
      if (fieldData.current[field.id]) {
        if (field.type === _constants.FIELD_TYPES.RICH_TEXT_FIELD) {
          fieldData.current[field.id].isValid = true;
        }
        fieldData.current[field.id].isHidden = !isFieldVisible;
      }
    });
    var fallbackKey = "fallback-key-".concat((0, _uuid.v4)());
    return isFieldVisible && (_option$conditionalFi2 = option.conditionalFieldGroup) !== null && _option$conditionalFi2 !== void 0 && _option$conditionalFi2.fields ? /*#__PURE__*/_react.default.createElement(_FieldGroup.default, {
      "data-testid": "conditional-field-group-test",
      key: "conditional-field-group-".concat((_option$conditionalFi3 = option.conditionalFieldGroup) === null || _option$conditionalFi3 === void 0 ? void 0 : _option$conditionalFi3.id),
      heading: option === null || option === void 0 || (_option$conditionalFi4 = option.conditionalFieldGroup) === null || _option$conditionalFi4 === void 0 ? void 0 : _option$conditionalFi4.heading,
      subheading: option === null || option === void 0 || (_option$conditionalFi5 = option.conditionalFieldGroup) === null || _option$conditionalFi5 === void 0 ? void 0 : _option$conditionalFi5.subheading,
      fields: option === null || option === void 0 || (_option$conditionalFi6 = option.conditionalFieldGroup) === null || _option$conditionalFi6 === void 0 ? void 0 : _option$conditionalFi6.fields,
      fieldData: fieldData,
      fieldValues: fieldValues,
      language: language,
      removeSpacing: option === null || option === void 0 || (_option$conditionalFi7 = option.conditionalFieldGroup) === null || _option$conditionalFi7 === void 0 ? void 0 : _option$conditionalFi7.removeSpacing
      // mobileWidth={field.mobileWidth} // Can be added in future
      // tabletWidth={field.tabletWidth} // Can be added in future
      // desktopWidth={field.desktopWidth} // Can be added in future
      ,
      clickedSubmit: clickedSubmit,
      fieldReferences: fieldReferences,
      isConditionalField: true
    }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: "conditional-field-group-".concat((option === null || option === void 0 || (_option$conditionalFi8 = option.conditionalFieldGroup) === null || _option$conditionalFi8 === void 0 ? void 0 : _option$conditionalFi8.id) || fallbackKey)
    });
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, optionsRendered);
};
ConditionalField.propTypes = {
  field: _propTypes.default.shape({
    options: _propTypes.default.array,
    id: _propTypes.default.string
  }),
  fieldData: _propTypes.default.object,
  fieldReferences: _propTypes.default.object,
  fieldValues: _propTypes.default.object,
  clickedSubmit: _propTypes.default.bool,
  language: _propTypes.default.string
};
var _default = exports.default = ConditionalField;